import * as S from './styles'

export const AuthLoading = () => {
  return (
    <S.Container>
      <S.Loading enableTrackSlot size={100} thickness={7} />
    </S.Container>
  )
}
